import { useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { db } from '../lib/firebase';

// Live-listen to any tenant-level admin resource collection (labels, canned, inboxes, teams).
export function useResource<T>(collectionName: string): { items: T[]; loading: boolean } {
  const [items, setItems] = useState<T[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const q = query(collection(db, collectionName), orderBy('createdAt', 'desc'));
    const unsub = onSnapshot(
      q,
      (snap) => {
        setItems(snap.docs.map((d) => ({ id: d.id, ...(d.data() as Omit<T, 'id'>) } as unknown as T)));
        setLoading(false);
      },
      (err) => {
        console.error(`useResource(${collectionName}) listener error`, err);
        setLoading(false);
      }
    );
    return unsub;
  }, [collectionName]);
  return { items, loading };
}
